import styled from "styled-components";

export const StyledPalette = styled.div`
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  > div {
    flex-basis: calc(50% - 8px);
    min-height: 506px;
    background-color: ${({ theme }) => theme.colors.neutralsWhiteTint60};
    border-radius: 4px;

    &:last-child {
      flex-basis: 100%;
    }
  }
`;
